export function goToUrl(url) {
  window.location.href = url;
}